// extracted by mini-css-extract-plugin
export default {"container":"container-DJE4_","text":"text-cR2hC","button":"button-ilqzb"};